module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar",
    staticStyle: {
      "overflow-y": "auto",
      "height": "100vh",
      "padding-bottom": "100px"
    }
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("SGP - MENU")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.rota
    },
    on: {
      "click": _vm.validaRota
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', [_vm._v("Inicial")])])], 1), _vm._v(" "), (this.$root.authorize('perfil-visualizar')) ? _c('li', {
    staticClass: "treeview",
    attrs: {
      "data-widget": "tree"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li'), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-editais-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Editais")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('entidade-visualizar|entidade-visualizar-por-mim')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-entidade-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Entidades")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('fav-editar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-fep-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" FEP")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-formulario'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Formulários")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-ged'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" GED")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('motivo-devolucao-criar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-motivos-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Motivos de Devolução (Gepac)")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lista-articulacoes'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Parcerias Estratégicas")]) : _vm._e()], 1), _vm._v(" "), (false) ? _c('li', [(this.$root.authorize('parceiro-estrategico-visualizar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-parceiro-estrategico-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Parceiros Estratégicos")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', [(this.$root.authorize('permissao-editar')) ? _c('a', {
    attrs: {
      "href": this.$store.state.laravelurl + '/nova/resources/perfils',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Perfis")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('permissao-editar')) ? _c('a', {
    attrs: {
      "href": this.$store.state.laravelurl + '/nova/resources/permissaos',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Permissões")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('permissao-editar')) ? _c('a', {
    attrs: {
      "href": this.$store.state.laravelurl + '/nova/resources/tipo-documentos',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Tipos de documentos")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('permissao-editar')) ? _c('a', {
    attrs: {
      "href": this.$store.state.laravelurl + '/nova/resources/users',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Usuários")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lista-sumario-executivo'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Sumário Executivo")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'projetos-usuarios'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Usuários por Projeto")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lista-ocorrencias'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Ocorrências")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lista-ods-fundacao'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" ODS ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lista-cotacao-automatica-excecoes'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Cotação Automática ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'propostas-simplificadas'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Processo Simplificado ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439 && !_vm.ehParceiroEstrategico) ? _c('li', [(this.$root.authorize('minha-entidade-visualizar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-entidade-edita',
        params: {
          id: _vm.usuarioLogado.entidade.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', [_vm._v("Dados Cadastrais")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', [(this.$root.authorize('ged-editar') && _vm.usuarioLogado.strategicPartner) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-ged'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', [_vm._v("GED")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('meu-parceiro-estrategico-visualizar')) ? _c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Dados Cadastrais")])]) : _vm._e()], 1), _vm._v(" "), (_vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439 || _vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.propostas))) ? _c('li', [(this.$root.authorize('proposta-visualizar-por-mim|proposta-visualizar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'proposta-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" "), _c('span', [_vm._v("Propostas")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.ehParceiroEstrategico && _vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439 || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.propostas))) ? _c('li', [(this.$root.authorize('minha-proposta-visualizar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'proposta-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" "), _c('span', [_vm._v("Minhas propostas")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos)) || _vm.ehParceiroEstrategico) ? _c('li', [(this.$root.authorize('projeto-visualizar|projeto-visualizar-por-mim|meu-projeto-visualizar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lista-projetos'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-rocket"
  }), _c('span', [_vm._v(" Projetos")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos)) || _vm.ehParceiroEstrategico) ? _c('li', [(this.$root.authorize('solicitacao-pagamento-editar|solicitacao-contrapartida-editar|solicitacao-adiantamento-editar|solicitacao-prestacaocontas-editar|solicitacao-devolucaoadiantamento-editar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'solicitacao-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Solicitações")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos) && _vm.prestacaoSimplificada)) ? _c('li', [(this.$root.authorize('solicitacao-pagamento-editar|solicitacao-contrapartida-editar|solicitacao-adiantamento-editar|solicitacao-prestacaocontas-editar|solicitacao-devolucaoadiantamento-editar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'prestacao-contas-simplificada'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  }), _vm._v(" "), _c('span', [_vm._v("Prestação de Contas")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.$root.authorize('entidade-validar|pre-analise-primeira-aprovacao-validar|pre-analise-segunda-aprovacao-validar|aceite-proposta-validar|analise-aprovacao-validar|analise-pendencia-aprovacao-validar|deferimento-aprovacao-validar|preparacao-documentos-aprovacao-validar|formalizacao-projetos-aprovacao-validar|relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia|solicitacao-pagamento-analisar|solicitacao-pagamento-acompanhar|solicitacao-contrapartida-analisar|solicitacao-adiantamento-analisar|solicitacao-adiantamento-aprovar|solicitacao-adiantamento-analisefinanceira|solicitacao-devolucaoadiantamento-analisar|solicitacao-devolucaoadiantamento-analisefinanceira|solicitacao-prestacaocontas-analisar|solicitacao-prestacaocontas-analisefinanceira|parceiro-estrategico-validar')) ? _c('li', {
    staticClass: "treeview",
    attrs: {
      "data-widget": "tree"
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$root.authorize('entidade-validar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'validacao-solicitacoes-lista',
        params: {
          fase: _vm.parametroEnt
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Entidades")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('pre-analise-primeira-aprovacao-validar|pre-analise-segunda-aprovacao-validar|aceite-proposta-validar|analise-aprovacao-validar|analise-pendencia-aprovacao-validar|deferimento-aprovacao-validar|preparacao-documentos-aprovacao-validar|formalizacao-projetos-aprovacao-validar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'validacao-solicitacoes-lista',
        params: {
          fase: _vm.parametroProp
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('span', [_vm._v("Propostas")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'validacao-solicitacoes-lista',
        params: {
          fase: _vm.parametroRel
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Relatório de Execução")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('solicitacao-pagamento-analisar|solicitacao-pagamento-acompanhar|solicitacao-contrapartida-analisar|solicitacao-adiantamento-analisar|solicitacao-adiantamento-aprovar|solicitacao-adiantamento-analisefinanceira|solicitacao-devolucaoadiantamento-analisar|solicitacao-devolucaoadiantamento-analisefinanceira|solicitacao-prestacaocontas-analisar|solicitacao-prestacaocontas-analisefinanceira')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'validacao-solicitacoes-financeiras-lista',
        params: {
          fase: _vm.parametroSol
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Execução financeira")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO' && this.$root.authorize('solicitacao-pagamento-analisar|solicitacao-pagamento-acompanhar|solicitacao-contrapartida-analisar|solicitacao-adiantamento-analisar|solicitacao-adiantamento-aprovar|solicitacao-adiantamento-analisefinanceira|solicitacao-devolucaoadiantamento-analisar|solicitacao-devolucaoadiantamento-analisefinanceira|solicitacao-prestacaocontas-analisar|solicitacao-prestacaocontas-analisefinanceira')) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.abreLaravelAutenticado('/sgp/esteira-automatica')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Esteira Automática "), _c('i', {
    staticClass: "fa fa-external-link",
    staticStyle: {
      "font-size": "10px"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'validacao-solicitacoes-lista',
        params: {
          fase: _vm.parametroAval
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Avaliação de projetos")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'validacao-solicitacoes-lista',
        params: {
          fase: _vm.parametroOco
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Ocorrências")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'validacao-solicitacoes-lista',
        params: {
          fase: _vm.parametroAltPrj
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Alterações de projetos")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-execucao-aprovar-envio|relatorio-execucao-aprovar-pendencia')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'validacao-licencas',
        params: {
          fase: _vm.parametroLicAmb
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Licenciamento Ambiental")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-agencia-configurar|usuario-fundacao-configurar|usuario-entidade-configurar|usuario-estrategico-configurar|usuario-superintendencia-configurar|entidade-configurar|proposta-configurar')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$root.authorize('usuario-agencia-configurar|usuario-fundacao-configurar|usuario-entidade-configurar|usuario-estrategico-configurar|usuario-superintendencia-configurar|entidade-configurar|proposta-configurar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'impressao-relatorio'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Relatórios da Proposta")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.abreLaravelAutenticado('/sgp/relatorios/extrato-bndes?menu=oculto')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" Prestação de Contas - BNDES")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('solicitacao-ratificacao')) ? _c('a', {
    attrs: {
      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/e-mails%20FBB?rs:embed=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" BI - Acompanhamento de E-mails")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('solicitacao-ratificacao')) ? _c('a', {
    attrs: {
      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/SGP%20-%20Estat%C3%ADsticas%20de%20Processos?rs:embed=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" BI - Estatística de Processos")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('geracao-remessa-pagamento|movimento-diario|solicitacao-ratificacao|bi-baixa-prestacao')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.ativaGeracaoRemessa) ? _c('li', [(this.$root.authorize('geracao-remessa-pagamento')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'geracao-remessa'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Geração de Remessa")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.ativaGeracaoRemessa) ? _c('li', [(this.$root.authorize('geracao-remessa-pagamento')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'tratamento-retorno'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Tratamento de Retorno")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', [(this.$root.authorize('movimento-diario')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'movimento-diario'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Movimento Diário")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('solicitacao-ratificacao')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lista-ratificacao'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Ratificações")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('controle_bndes_pagamentos')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lista-remessa-bndes'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Remessas BNDES")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('bi-baixa-prestacao')) ? _c('a', {
    attrs: {
      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/Baixas%20de%20Presta%C3%A7%C3%A3o%20de%20Contas?rs:embed=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" BI - Baixa de Prestações")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.abreLaravelAutenticado('/sgp/relatorios/retornos-pe?menu=oculto')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" BI - Relatório Remessas")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('relatorio-erp-novo|relatorio-erp-editar|relatorio-erp-excluir|relatorio-erp-visualizar|relatorio-erp-emissao') || _vm.ehParceiroEstrategico) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$root.authorize('relatorio-erp-visualizar|relatorio-erp-novo|relatorio-erp-editar|relatorio-erp-excluir')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-relatorio'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Cadastro")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('relatorio-erp-emissao') || _vm.ehParceiroEstrategico) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'emite-relatorio'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Emissão")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), ((_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.$root.authorize('chamado-visualizar')) || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos))) ? _c('li', {
    staticClass: "treeview",
    attrs: {
      "data-widget": "tree"
    }
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$root.authorize('chamado-novo')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'abrir-chamado'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Abrir Chamado")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('chamado-visualizar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-chamado-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Listar Chamados")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('chamado-visualizar-assunto')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cadastro-assunto-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Gestão de Assuntos")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('chamado-relatorios')) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/BI%20-%20Chamados%20DQ?rs:embed=true"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Relatórios")]) : _vm._e()]), _vm._v(" "), _c('li', [(this.$root.authorize('chamado-visualizar')) ? _c('a', {
    attrs: {
      "href": "https://pwbi.intranet.bb.com.br/reports/powerbi/%5BInterna%5D/FBB/SGP/Chamados%20Encerrados?rs:embed=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" BI - Chamados Encerrados")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-agencia-configurar|usuario-fundacao-configurar|usuario-entidade-configurar|usuario-estrategico-configurar|usuario-superintendencia-configurar|entidade-configurar|proposta-configurar')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(6), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$root.authorize('usuario-agencia-configurar|usuario-fundacao-configurar|usuario-entidade-configurar|usuario-estrategico-configurar|usuario-superintendencia-configurar|entidade-configurar|proposta-configurar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'conf-gerais'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Configurações Gerais")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'log-edicao-proposta'
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Análise Logs")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$root.authorize('perfil-visualizar')) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'logs-email'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Log de E-mails Enviados")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || _vm.ehParceiroEstrategico || !_vm._.isEmpty(_vm.projetos)) ? _c('li', {
    staticClass: "treeview"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'manuais'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o"
  }), _vm._v(" "), _c('span', [_vm._v("Manuais e Modelos")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.usuarioLogado.strategicPartner && _vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439 && (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm._.isEmpty(_vm.projetos)))) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.propostas || _vm.loading.projetos),
      expression: "loading.propostas || loading.projetos"
    }],
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando menu ...")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v(" "), _c('span', [_vm._v("Cadastro")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-gavel"
  }), _vm._v(" "), _c('span', [_vm._v("Validação")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" "), _c('span', [_vm._v("Remessa")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios ERP")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _vm._v(" "), _c('span', [_vm._v("Chamados")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  }), _vm._v(" "), _c('span', [_vm._v("Configurações")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.fbb.org.br/projetos/portal",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', [_vm._v("Antigo SGP")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-563888d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = 1966
// module chunks = 1